export const SIMILAR_KYC_DOWNLOAD_HEADER = [
  {
    name: 'Customer ID No',
    label: 'Customer ID No',
    key: 'similarKycInfo.CUSTOMER_ID_NO'
  },
  {
    name: 'Customer ID',
    label: 'Customer ID',
    key: 'partyKey'
  },
  {
    name: 'Customer Name',
    label: 'Customer Name',
    key: 'similarKycInfo.PARTY_NAME'
  },
  {
    name: 'Customer Type',
    label: 'Customer Type',
    key: 'similarKycInfo.INDIVIDUAL_CORPORATE_TYPE'
  },
  {
    name: 'Email Address',
    label: 'Email Address',
    key: 'similarKycInfo.KYC_EMAIL_ADDRESS'
  },
  {
    name: 'Age',
    label: 'Age',
    key: 'similarKycInfo.PARTY_AGE'
  },
  {
    name: 'Risk Status',
    label: 'Risk Status',
    key: 'similarKycInfo.RISK_LEVEL'
  },
  {
    name: 'Occupation',
    label: 'Occupation',
    key: 'similarKycInfo.OCCUPATION'
  },
  {
    name: 'Mailing Address',
    label: 'Mailing Address',
    key: 'similarKycInfo.KYC_MAILING_ADDRESS'
  },
  {
    name: 'Residence address',
    label: 'Residence address',
    key: 'similarKycInfo.RESIDENTIAL_ADDRESS'
  },
  {
    name: 'Country of Residence',
    label: 'Country of Residence',
    key: 'similarKycInfo.RESIDENCE_OPERATION_COUNTRY'
  },
  {
    name: 'Contact Number',
    label: 'Contact Number',
    key: 'similarKycInfo.CUSTOMER_CONTACT_NO'
  },
  {
    name: 'Authorized signatory details',
    label: 'Authorized signatory details',
    key: 'similarKycInfo.KYC_AUTHORISED_SIGNATORY_PERSON'
  },
  {
    name: 'Duplicate With',
    label: 'Duplicate With',
    key: 'similarKycFields',
    formatter: (row) => row.similarKycFields.join(', ')
  }
];
